import { call, put, takeEvery } from 'redux-saga/effects';
import { searchBikeModel, countBikeModels } from '../../requests/search_bike_model_request';
import { searchBikeModelRequestSuccess, searchBikeModelRequestFailure } from '../actions/search_bike_model.actions';
import { SEARCH_BIKE_MODEL_REQUEST } from '../constants/bike_model.constants';

import { countBikeModelsRequestFailure, countBikeModelsRequestSuccess } from '../actions/count_bike_models.actions';

function* searchBikeModelRequest({ value, brand_id }) {
    const models = yield call(searchBikeModel, value, brand_id);

    if (models.result) {
        yield put(searchBikeModelRequestSuccess(models.options));
    } else {
        yield put(searchBikeModelRequestFailure(models.error));
    }
}

export default function* searchBikeModelSaga() {
    yield takeEvery(SEARCH_BIKE_MODEL_REQUEST, searchBikeModelRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/sagas/search_bike_model.saga.js